module.exports = __webpack_public_path__ + "img/pause.98db4ff1.svg";